import React from "react";
import PropTypes from "prop-types";
import { ProductData } from "../types/index.js";
import ProductPreview from "../../productPreview/index.js";

function ProductsDetails(element) {
  const { brand, productId, status, website } = element;

  return (
    <>
      <div style={{ marginBottom: "2%" }}>
        <ProductPreview row={element} isMobile />
      </div>
      <div style={{ marginBottom: "2%" }}>
        <b>Brand: </b>
        {brand}
      </div>
      <div style={{ marginBottom: "2%" }}>
        <b>Website: </b>
        {website}
      </div>
      <div style={{ marginBottom: "2%" }}>
        <b>Product ID: </b>
        {productId}
      </div>
      <div style={{ marginBottom: "2%" }}>
        <b>Status: </b>
        {status}
      </div>
    </>
  );
}

ProductsDetails.propTypes = {
  element: PropTypes.shape(ProductData),
};

export default ProductsDetails;
